/** @jsxImportSource @emotion/react */
"use client";

import { usePathname } from "next/navigation";
import Link from "next/link";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Box from "@mui/material/Box";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import { linkStyles } from "./styles";

const breadcrumbMap: Record<string, string> = {
  urunler: "Ürünler",
  hakkimizda: "Hakkımızda",
  iletisim: "İletişim",
  blog: "Blog",
};

interface BreadcrumbNavProps {
  title?: string;
}

export const BreadcrumbNav = ({ title }: BreadcrumbNavProps) => {
  const pathname = usePathname();
  const segments = pathname.split("/").filter(Boolean);

  const baseBreadcrumbs = [
    { label: "Anasayfa", href: "/" },
    ...segments.map((segment, idx) => {
      const href = "/" + segments.slice(0, idx + 1).join("/");
      const label =
        breadcrumbMap[segment.toLowerCase()] ||
        decodeURIComponent(segment)
          .replace(/-/g, " ")
          .replace(/\b\w/g, (l) => l.toUpperCase());
      return { label, href };
    }),
  ];

  const breadcrumbs =
    baseBreadcrumbs.length > 2
      ? [
          ...baseBreadcrumbs.slice(0, -1),
          { label: title, href: pathname }, // Add the current page title
        ]
      : baseBreadcrumbs;

  return (
    <Box my={2}>
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={<NavigateNextIcon fontSize="small" sx={{ color: "gray" }} />}
      >
        {breadcrumbs.map((item, index) =>
          index === breadcrumbs.length - 1 ? (
            <Typography key={index} color="text.secondary">
              {item.label}
            </Typography>
          ) : (
            <Link key={index} href={item.href} css={linkStyles}>
              {item.label}
            </Link>
          ),
        )}
      </Breadcrumbs>
    </Box>
  );
};
